import locationService from '../../services/location/LocationService.js'
import deliveryPointService from '../../services/delivery-point/DeliveryPointService'
import serviceCalendar from '../../services/calendarAppointment/serviceCalendar'
import * as moment from 'moment'

export default {
  components: {},
  data () {
    return {
      listDeliveryPoints: [],
      deliveryPoints: [],
      cities: [],
      states: [],
      configurations1: [
        {
          daysOfWeekSelected: [],
          initialTime1: '',
          initialTime2: '',
          initialTime3: '',
          finalTime1: '',
          finalTime2: '',
          finalTime3: '',
          timeRange: '10 min',
          capacity: '',
          responseDays: 0
        }
      ],
      initialDate: '',
      finalDate: '',
      initialDateMenu: false,
      finalDateMenu: false,
      configuration2: {
        date: '',
        active: true,
        initialTime1: '',
        initialTime2: '',
        initialTime3: '',
        finalTime1: '',
        finalTime2: '',
        finalTime3: '',
        timeRange: '10 min',
        capacity: '',
        responseDays: 0,
        dateMenu: false
      },
      daysOfWeek: [
        {
          id: 0,
          name: 'Domingo'
        },
        {
          id: 1,
          name: 'Lunes'
        },
        {
          id: 2,
          name: 'Martes'
        },
        {
          id: 3,
          name: 'Miércoles'
        },
        {
          id: 4,
          name: 'Jueves'
        },
        {
          id: 5,
          name: 'Viernes'
        },
        {
          id: 6,
          name: 'Sábado'
        }
      ],
      hourItems: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      minuteItems1: ['00', '30'],
      minuteItems2: ['00', '30'],
      timeRangeItems: ['5 min', '10 min', '15 min', '30 min', '60 min'],
      timeConfigurationItems: ['AM', 'PM'],
      minDate: '',
      minDate2: '',
      selectedStates: [],
      selectedCities: [],
      maxDate: '',
      today: '',
      loadingSave1: false,
      selectedState: '',
      selectedCity: '',
      deliveryPoint: '',
      alreadyExists: false,
      editScheduleRanges: false,
      loadedConfig: false,
      loadingSave2: false
    }
  },
  async created () {
    await this.getStates()
    this.initialDate = moment().format('YYYY-MM-DD')
    this.minDate = this.initialDate
    this.maxDate = moment().add(2, 'years').format('YYYY-MM-DD')
    this.today = moment().format('YYYY-MM-DD')
  },
  computed: {
    allDeliveryPointSelected () {
      return this.deliveryPoints.length === this.listDeliveryPoints.length
    },
    someDeliveryPointsSelected () {
      return this.deliveryPoints.length > 0 && !this.likesAllFruit
    },
    iconSelect () {
      if (this.allDeliveryPointSelected) return 'mdi-close-box'
      if (this.someDeliveryPointsSelected) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },
  methods: {
    toggle () {
      this.$nextTick(() => {
        if (this.likesAllFruit) {
          this.deliveryPoints = []
        } else {
          this.deliveryPoints = this.listDeliveryPoints.slice()
        }
      })
    },
    changeTimeRange1 (index) {
      this.configurations1[index].initialTime2 = ''
      this.configurations1[index].finalTime2 = ''
    },
    changeTimeRange2 (index) {
      this.configuration2.initialTime2 = ''
      this.configuration2.finalTime2 = ''
    },
    addConfiguration1 () {
      this.configurations1.push(
        {
          daysOfWeekSelected: [],
          initialTime1: '',
          initialTime2: '',
          initialTime3: '',
          finalTime1: '',
          finalTime2: '',
          finalTime3: '',
          timeRange: '10 min',
          capacity: '',
          responseDays: 0
        }
      )
    },
    deleteConfiguration1 (index) {
      this.configurations1.splice(index, 1)
    },
    changeInitialDate () {
      let initialDate = moment(this.initialDate).format('YYYY-MM-DD')
      this.minDate = initialDate
      if (this.finalDate !== null & this.finalDate !== undefined && this.finalDate !== '') {
          if (!moment(this.finalDate).isSameOrAfter(initialDate)) {
              this.finalDate = this.minDate
          }
      } else {
          this.finalDate = this.minDate
      }
      this.maxDate = moment(this.initialDate).add(2, 'years').format('YYYY-MM-DD')
    },
    async getConfig () {
      try {
        if (this.configuration2.date === '' || this.configuration2.date === undefined || this.configuration2.date === null) {
          this.$notify({
            group: "app",
            type: "error",
            text: 'Debe seleccionar una fecha'
          })
          return 
        }
        if (this.deliveryPoint === '' || this.deliveryPoint === undefined || this.deliveryPoint === null) {
          this.$notify({
            group: "app",
            type: "error",
            text: 'Debe seleccionar un punto de entrega'
          })
          return 
        }
        const body = {
          date: this.configuration2.date,
          deliveryPoint: this.deliveryPoint
        }
        let response = await serviceCalendar.getCalendarConfiguration(body)
        if (response.data === 'No config') {
          this.alreadyExists = false
        } else {
          let config = response.data
          this.configuration2.responseDays = config.responseDays
          if (config.scheduleRangesAppointment) {
            this.configuration2.capacity = config.scheduleRangesAppointment[0].maxCapacity
          }
          this.alreadyExists = true
        }
        this.loadedConfig = true
      } catch (error) {
        this.$notify({
          group: "app",
          type: "error",
          text: 'Error'
        })
      }
    },
    changeDate () {
      this.configuration2.initialTime1 = ''
      this.configuration2.initialTime2 = ''
      this.configuration2.initialTime3 = ''
      this.configuration2.finalTime1 = ''
      this.configuration2.finalTime2 = ''
      this.configuration2.finalTime3 = ''
      this.configuration2.capacity = ''
      this.configuration2.responseDays = 0
      this.configuration2.initialTime1 = '10 min'
    },
    filterKey (e) {
      const key = e.key
      if (/[0-9]/.test(key)) { } else { return e.preventDefault() }
    },
    async getStates () {
      try {
        let response = await locationService.getStatesWithDeliveryPoint()
        this.states = response.data
        this.state = ''
        this.city = ''
      } catch (error) {
        this.$notify({
          group: "app",
          type: "error",
          text: 'Error'
        })
      }
    },
    async save1 () {
      this.loadingSave1 = true
      if (this.deliveryPoints.length === 0) {
        this.$notify({
          group: "app",
          type: "error",
          text: 'Debe seleccionar al menos un punto de entrega'
        })
        this.loadingSave1 = false
        return
      }
      if (this.initialDate === null || this.initialDate === undefined || this.initialDate === '') {
        this.$notify({
          group: 'app',
          type: 'error',
          text: 'Debe seleccionar la fecha inicial'
        })
        this.loadingSave1 = false
        return
      }
      if (this.finalDate === null || this.finalDate === undefined || this.finalDate === '') {
        this.$notify({
          group: 'app',
          type: 'error',
          text: 'Debe seleccionar la fecha final'
        })
        this.loadingSave1 = false
        return
      }
      for (let i = 0; i < this.configurations1.length; i++) {
        if (this.configurations1[i].daysOfWeekSelected.length === 0) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: `Debe seleccionar al menos un dia de la semana en la configuracion ${i+1}`
          })
          this.loadingSave1 = false
          return
        }
        if (this.configurations1[i].capacity === null || this.configurations1[i].capacity === undefined || this.configurations1[i].capacity === '') {
          this.$notify({
            group: 'app',
            type: 'error',
            text: `Debe ingresar la capacidad en la configuracion ${i+1}`
          })
          this.loadingSave1 = false
          return
        }
        if (this.configurations1[i].responseDays === null || this.configurations1[i].responseDays === undefined || this.configurations1[i].responseDays === '') {
          this.$notify({
            group: 'app',
            type: 'error',
            text: `Debe ingresar los dias de respuesta en la configuracion ${i+1}`
          })
          this.loadingSave1 = false
          return
        }
        if (
          this.configurations1[i].initialTime1 === null || this.configurations1[i].initialTime1 === undefined || this.configurations1[i].initialTime1 === '' ||
          this.configurations1[i].initialTime2 === null || this.configurations1[i].initialTime2 === undefined || this.configurations1[i].initialTime2 === '' ||
          this.configurations1[i].initialTime3 === null || this.configurations1[i].initialTime3 === undefined || this.configurations1[i].initialTime3 === ''
        ) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: `Faltan campos de la hora inicial en la configuración ${i+1}`
          })
          this.loadingSave1 = false
          return
        }
        if (
          this.configurations1[i].finalTime1 === null || this.configurations1[i].finalTime1 === undefined || this.configurations1[i].finalTime1 === '' ||
          this.configurations1[i].finalTime2 === null || this.configurations1[i].finalTime2 === undefined || this.configurations1[i].finalTime2 === '' ||
          this.configurations1[i].finalTime3 === null || this.configurations1[i].finalTime3 === undefined || this.configurations1[i].finalTime3 === ''
        ) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: `Faltan campos de la hora final en la configuración ${i+1}`
          })
          this.loadingSave1 = false
          return
        }
        if (
          this.configurations1[i].initialTime1 === this.configurations1[i].finalTime1 &&
          this.configurations1[i].initialTime2 === this.configurations1[i].finalTime2 &&
          this.configurations1[i].initialTime3 === this.configurations1[i].finalTime3
        ) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: `La hora final debe ser mayor que la hora inicial en la configuración ${i+1}`
          })
          this.loadingSave1 = false
          return
        }
        const initialTime = moment(`1990-01-01 ${this.configurations1[i].initialTime1}:${this.configurations1[i].initialTime2} ${this.configurations1[i].initialTime3}`)
        const finalTime = moment(`1990-01-01 ${this.configurations1[i].finalTime1}:${this.configurations1[i].finalTime2} ${this.configurations1[i].finalTime3}`)
        if (initialTime.isAfter(finalTime)) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: `La hora final debe ser mayor que la hora inicial en la configuración ${i+1}`
          })
          this.loadingSave1 = false
          return
        }
      }
      const body = {
        initialDate: this.initialDate,
        finalDate: this.finalDate,
        configurations: this.configurations1,
        deliveryPoints: this.deliveryPoints
      }
      try {
        let response = await serviceCalendar.create(body)
        this.$notify({
          group: 'app',
          type: 'success',
          text: 'Calendario configurado exitosamente'
        })
        this.loadingSave1 = false
        this.clear1()
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: error
        })
        this.loadingSave1 = false
      }
    },
    async save2 () {
      this.loadingSave2 = true
      if (this.configuration2.date === '' || this.configuration2.date === undefined || this.configuration2.date === null) {
        this.$notify({
          group: "app",
          type: "error",
          text: 'Debe seleccionar una fecha'
        })
        this.loadingSave2 = false
        return 
      }
      if (this.deliveryPoint === '' || this.deliveryPoint === undefined || this.deliveryPoint === null) {
        this.$notify({
          group: "app",
          type: "error",
          text: 'Debe seleccionar un punto de entrega'
        })
        this.loadingSave2 = false
        return 
      }
      if (this.configuration2.responseDays === '' || this.configuration2.responseDays === undefined || this.configuration2.responseDays === null) {
        this.$notify({
          group: "app",
          type: "error",
          text: 'Debe ingresar los días de respuesta'
        })
        this.loadingSave2 = false
        return 
      }
      if (this.configuration2.capacity === '' || this.configuration2.capacity === undefined || this.configuration2.capacity === null) {
        this.$notify({
          group: "app",
          type: "error",
          text: 'Debe ingresar la capacidad'
        })
        this.loadingSave2 = false
        return 
      }
      if ((!this.alreadyExists && this.configuration2.active) || this.editScheduleRanges) {
        if (
          this.configuration2.initialTime1 === null || this.configuration2.initialTime1 === undefined || this.configuration2.initialTime1 === '' ||
          this.configuration2.initialTime2 === null || this.configuration2.initialTime2 === undefined || this.configuration2.initialTime2 === '' ||
          this.configuration2.initialTime3 === null || this.configuration2.initialTime3 === undefined || this.configuration2.initialTime3 === ''
        ) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: `Faltan campos de la hora inicial`
          })
          this.loadingSave2 = false
          return
        }
        if (
          this.configuration2.finalTime1 === null || this.configuration2.finalTime1 === undefined || this.configuration2.finalTime1 === '' ||
          this.configuration2.finalTime2 === null || this.configuration2.finalTime2 === undefined || this.configuration2.finalTime2 === '' ||
          this.configuration2.finalTime3 === null || this.configuration2.finalTime3 === undefined || this.configuration2.finalTime3 === ''
        ) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: `Faltan campos de la hora final`
          })
          this.loadingSave2 = false
          return
        }
        if (
          this.configuration2.initialTime1 === this.configuration2.finalTime1 &&
          this.configuration2.initialTime2 === this.configuration2.finalTime2 &&
          this.configuration2.initialTime3 === this.configuration2.finalTime3
        ) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: `La hora final debe ser mayor que la hora inicial`
          })
          this.loadingSave2 = false
          return
        }
        const initialTime = moment(`1990-01-01 ${this.configuration2.initialTime1}:${this.configuration2.initialTime2} ${this.configuration2.initialTime3}`)
        const finalTime = moment(`1990-01-01 ${this.configuration2.finalTime1}:${this.configuration2.finalTime2} ${this.configuration2.finalTime3}`)
        if (initialTime.isAfter(finalTime)) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: `La hora final debe ser mayor que la hora inicial`
          })
          this.loadingSave2 = false
          return
        }
      }
      const body = {
        deliveryPoint: this.deliveryPoint,
        configuration: this.configuration2,
        editScheduleRanges: this.editScheduleRanges
      }
      try {
        let response = await serviceCalendar.edit(body)
        this.$notify({
          group: 'app',
          type: 'success',
          text: 'Calendario configurado exitosamente'
        })
        this.loadingSave2 = false
        this.clear2()
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: error
        })
        this.loadingSave2 = false
      }
    },
    cancel1 () {
      const accept = confirm("¿Está seguro de que desea cancelar?");
      if (accept) {
        this.clear1()
      }
    },
    clear1 () {
      this.configurations1 = [
        {
          daysOfWeekSelected: [],
          initialTime1: '',
          initialTime2: '',
          initialTime3: '',
          finalTime1: '',
          finalTime2: '',
          finalTime3: '',
          timeRange: '10 min',
          capacity: '',
          responseDays: 0
        }
      ]
      this.initialDate = ''
      this.finalDate = ''
      this.deliveryPoints = []
      this.selectedCities = []
      this.selectedStates = []
    },
    cancel2 () {
      const accept = confirm("¿Está seguro de que desea cancelar?");
      if (accept) {
        this.clear2()
      }
    },
    clear2 () {
      this.deliveryPoint = ''
      this.selectedCity = ''
      this.selectedState = ''
      this.configuration2.date = ''
      this.configuration2.initialTime1 = ''
      this.configuration2.initialTime2 = ''
      this.configuration2.initialTime3 = ''
      this.configuration2.finalTime1 = ''
      this.configuration2.finalTime2 = ''
      this.configuration2.finalTime3 = ''
      this.configuration2.capacity = ''
      this.configuration2.responseDays = ''
      this.configuration2.initialTime1 = '10 min'
      this.alreadyExists = false
      this.editScheduleRanges = false
      this.loadedConfig = false
    },
    async getCities () {
      try {
        const data = {
          ids: this.selectedStates
        }
        let response = await locationService.getCitiesWithDeliveryPoint(data)
        this.cities = response.data
        this.city = ''
      } catch (error) {
        console.log(error)
        this.$notify({
          group: "app",
          type: "error",
          text: 'Error'
        })
      }
    },
    async getCities2 () {
      try {
        const data = {
          ids: [this.selectedState]
        }
        let response = await locationService.getCitiesWithDeliveryPoint(data)
        this.cities = response.data
        this.city = ''
      } catch (error) {
        console.log(error)
        this.$notify({
          group: "app",
          type: "error",
          text: 'Error'
        })
      }
    },
    async getDeliveryPoints () {
      try {
        const data = {
          ids: this.selectedCities
        }
        let response = await deliveryPointService.getByCities(data)
        this.listDeliveryPoints = response.data
        this.deliveryPoints = []
      } catch (error) {
        console.log(error)
        this.$notify({
          group: "app",
          type: "error",
          text: 'Error'
        })
      }
    },
    async getDeliveryPoints2 () {
      try {
        const data = {
          ids: [this.selectedCity]
        }
        let response = await deliveryPointService.getByCities(data)
        this.listDeliveryPoints = response.data
        this.deliveryPoints = []
      } catch (error) {
        console.log(error)
        this.$notify({
          group: "app",
          type: "error",
          text: 'Error'
        })
      }
    },
    validateCapacity(capacity, index) {
      if (capacity > 1000) this.configurations1[index].capacity = 1000
    },
    validateResponseDays(responseDays, index) {
      if (responseDays > 10) this.configurations1[index].responseDays = 10
    }
  }
}
